import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import StreamViewer from '@/ui/pages/StreamViewer/StreamViewer';

export const Route = createFileRoute('/_dashboard/streams/$sessionId')({
  beforeLoad: requireRoute('/streams/$sessionId'),
  component: StreamViewer,
});
